const STORAGE_KEY = 'volyx.postAuthRedirect';

/** Persist a path (+ query) to return to after login or onboarding. */
export function savePostAuthRedirect(path: string) {
  if (typeof window === 'undefined') return;
  if (!path.startsWith('/') || path.startsWith('//')) return;
  sessionStorage.setItem(STORAGE_KEY, path);
}

/** Read and clear the saved redirect path. */
export function consumePostAuthRedirect(): string | null {
  if (typeof window === 'undefined') return null;
  const path = sessionStorage.getItem(STORAGE_KEY);
  if (path) sessionStorage.removeItem(STORAGE_KEY);
  if (!path || !path.startsWith('/') || path.startsWith('//')) return null;
  return path;
}

/** Default landing path when no redirect is stored. */
export function getPostAuthRedirectOrDefault(defaultPath = '/organizations'): string {
  return consumePostAuthRedirect() ?? defaultPath;
}
